<template>
  <div class="keywordPlanning">
    <el-row class="keywordHead">
      <keyword-head
        :content="websiteDetail"
        :customerId="customerId"
        :id="id"
        divisive="1"
      ></keyword-head>
    </el-row>
    <el-row class="keywordContent">
      <!-- 关键词列表 -->
      <el-col
        :span="12"
        class="keywordList"
      >
        <keyword-list
          ref="keywordList"
          :column="column1"
          :groups="groupsList"
          :isShowBtn='true'
          :optimizeListLength="optimizeListLength"
          @selectionChange="addSelectionChange"
          @addOptimize='addOptimize'
          @search="search"
        ></keyword-list>
        <!-- <el-button
          class="search"
          type="primary"
          @click="search"
        >搜索</el-button> -->
      </el-col>
      <!-- 已优化关键词 -->
      <el-col
        :span="12"
        class="keywordOptimize"
      >
        <keyword-optimize
          ref="keywordOptimize"
          :column="column2"
          :groups="groupsOptimize"
          :isShowItem="true"
          :selection="true"
          :isShowHeader="true"
          :isShowBtn="true"
          :isFilter="true"
          :keywordPlanning="true"
          :idsLength="idsLength"
          @delOptimize="delOptimize"
          @selectionChange="delSelectionChange"
        ></keyword-optimize>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import keywordList from "@/components/SEO/keywordList";
import keywordOptimize from "@/components/SEO/keywordOptimize";
import keywordHead from "@/components/SEO/keywordHead";
import articleBtn from "@/components/SEO/articleBtn";
import store from "@/backend/store/index";
import seo from "@/backend/services/seo/seoBoard.js";
export default {
  data() {
    const that = this;
    const column1 = [
      {
        label: "关键词",
        type: "articleAssistant",
        distinction: 'search',
        width: 350,
        articleAssistant(name) {
          that.searchCon = name;
          that.groups();
        }
      },
      {
        label: "搜索量",
        align: "center",
        bind: "avgMonthlySearchCount",
        sort: "avgMonthlySearchCount",
        options: [
          {
            label: "由低到高",
            value: "asc"
          },
          {
            label: "由高到低",
            value: "desc"
          }
        ]
      },
      {
        label: "竞争程度",
        align: "center",
        bind: "degreeCompetitionName",
        sort: "degreeCompetitionName",
        options: [
          {
            label: "由低到高",
            value: "asc"
          },
          {
            label: "由高到低",
            value: "desc"
          }
        ]
      }
    ];
    const column2 = [
      {
        label: "关键词",
        type: "articleAssistant",
        bind: "name",
        width: 250,
      },
      {
        label: "搜索量",
        align: "center",
        bind: "avgMonthlySearchCount",
        sort: "avgMonthlySearchCount",
        options: [
          {
            label: "由低到高",
            value: "asc"
          },
          {
            label: "由高到低",
            value: "desc"
          }
        ]
      },
      {
        label: "竞争程度",
        align: "center",
        bind: "degreeCompetitionName",
        sort: "degreeCompetition",
        options: [
          {
            label: "由低到高",
            value: "asc"
          },
          {
            label: "由高到低",
            value: "desc"
          }
        ]
      },
      {
        label: "生成文章",
        type: "custom",
        bind: "effectiveArticleCount",
        align: "center",
        componentName: articleBtn,
        query() {
          return { id: this.id };
        },
        sort: "effectiveArticleCount",
        options: [
          {
            label: "由低到高",
            value: "asc"
          },
          {
            label: "由高到低",
            value: "desc"
          }
        ]
      }
    ];
    return {
      groupsList: {
        others: [
          {
            tagName: "sky-input",
            placeholder: "关键词",
            label: "关键词",
            prop: "keywords",
            value: this.searchCon
          }
        ]
      },
      groupsOptimize: {},
      column1: column1,
      column2: column2,
      id: "",
      websiteDetail: "",
      searchCon: "",
      optimizeList: [],
      ids: [],
      optimizeListLength: 0,
      idsLength: 0
    };
  },
  props: [],
  methods: {
    // 多选事件
    addSelectionChange(val) {
      this.optimizeList = val;
      this.optimizeListLength = this.optimizeList.length
        ? this.optimizeList.length
        : 0;
    },
    delSelectionChange(val) {
      this.ids = val.map(item => item.id);
      this.idsLength = this.ids.length ? this.ids.length : 0;
    },
    // 添加优化
    async addOptimize() {
      if (this.optimizeList.length === 0) {
        this.$message({
          message: "请选择关键词",
          type: "warning",
          duration: 2000
        });
        return false;
      }

      let res = await seo.addoptimize({
        keywordList: this.optimizeList,
        seoSiteId: this.id
      });

      if (res.status === 201) {
        this.$refs.keywordOptimize.query();
        this.$refs.keywordOptimize.getkeywordstati();
        this.$message({
          message: "添加优化成功",
          type: "success",
          duration: 2000
        });
      }
    },
    // 删除优化
    async delOptimize() {
      if (this.ids.length === 0) {
        this.$message({
          message: "请选择关键词",
          type: "warning",
          duration: 2000
        });
        return false;
      }

      let res = await seo.deloptimize(this.ids);
      if (res.status === 204) {
        this.$refs.keywordOptimize.query();
        this.$refs.keywordOptimize.getkeywordstati();
        this.$message({
          message: "删除优化成功",
          type: "success",
          duration: 2000
        });
      }
    },
    // 获取网站详情
    async getWebsiteDetail() {
      let res = await seo.getwebsitedetail(this.id);
      this.websiteDetail = res.data;
    },
    search() {
      this.searchCon = this.groupsList.others[0].value;
      this.groups();
    },
    groups() {
      this.groupsList = {
        others: [
          {
            tagName: "sky-input",
            placeholder: "关键词",
            label: "关键词",
            prop: "keywords",
            value: this.searchCon
          }
        ]
      };
    }
  },
  components: { keywordList, keywordOptimize, keywordHead },
  created() {
    // 获取url参数
    this.id = this.$route.query.id;
    this.getWebsiteDetail();
  },
  computed: {
    // 客户Id
    customerId() {
      return store.getters.customerId;
    }
  }
};
</script>

<style scoped lang='scss'>
.keywordPlanning {
  background-color: #f1f4f9;
}
.keywordHead {
  width: 100%;
  font-size: 16px;
  color: #333;
  padding: 30px 20px 18px;
  background-color: #fff;
  margin-bottom: 10px;
}
.keywordContent {
  display: flex;
  justify-content: space-between;
  .keywordList,
  .keywordOptimize {
    flex: 1;
    padding: 0 10px;
    background-color: #fff;
  }
  .keywordList {
    margin-right: 5px;
    position: relative;
    .search {
      position: absolute;
      left: 200px;
      top: 21px;
      z-index: 3;
      color: #fff;
    }
  }
  .keywordOptimize {
    margin-left: 5px;
  }
}
</style>
